import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { getCookie, setCookie } from '../../utils/cookies';
import LayoutService from '../../layouts/service';

export const useLayoutStore = defineStore('layout', () => {
	const lang = ref(localStorage.getItem('lang') || 'en');
	const pageTitle = ref('');
	const sidebarCollapsedCookie = getCookie('sidebar_collapsed');
	const sidebarExpand = ref(
		sidebarCollapsedCookie === 'true' ? false : sidebarCollapsedCookie === '' ? true : true,
	);
	const pageClasses = ref('');
	const hasNewNotifications = ref(false);

	const isRTL = computed(() => {
		return lang.value === 'ar';
	});

	const setPageTitle = (title) => {
		pageTitle.value = title;
	};

	const setHasNewNotifications = (value) => {
		hasNewNotifications.value = value;
	};

	const toggleSidebarExpand = () => {
		sidebarExpand.value = !sidebarExpand.value;
		setCookie('sidebar_collapsed', sidebarExpand.value ? '' : 'true', 1000 * 1000);
	};

	const changeLang = async (locale) => {
		await LayoutService.changeLang(locale).finally(() => {
         localStorage.setItem('lang', locale);
         lang.value = locale;
      });
	};

	return { 
		lang, 
		pageTitle, 
		sidebarExpand, 
		isRTL, 
		pageClasses,
		hasNewNotifications,
		setPageTitle, 
		toggleSidebarExpand, 
		changeLang,
		setHasNewNotifications
	};
});
